<template>
    <div class="vote">
        <el-table :data="userlist" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="nickname" label="用户名"></el-table-column>
            <el-table-column prop="nickname" label="头像">
                <template slot-scope="scope">
                    <img :src="scope.row.avatar" alt="" width="50">
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="投票时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="查看投票记录" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="voteuser(scope.row)">查看</el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                userlist: [],
                vote_id: '',
                loading: false,
                height: null,
                pagesize: 10,
                currentPage: 1,
                count: 0,
            }
        },
        mounted() {
            this.getHeight()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            getvoteuserlist(id) {
                this.loading=true
                axios
                    .post("/admin/VoteHistoryRecord/getVotePeople", {
                        vote_id: id,
                        page: this.currentPage,
                        page_count: this.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.loading=false
                            this.userlist = response.data.data.data
                            this.count = response.data.data.count

                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            voteuser(data) {
                this.$nextTick(()=>{
                    this.$parent.$parent.uservoterecord=true
                    this.$nextTick(()=>{  
                    this.$parent.$parent.$refs.voterecord.getuservoterecord(data.create_user)
                    })
                   
                    
                })
            },
            handleCurrentChange(val) {
                this.currentPage=val
                this.getvoteuserlist(this.vote_id)
            },
            handleSizeChange(val) {
                this.pagesize=val
                this.currentPage=1
                this.getvoteuserlist(this.vote_id)
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>